import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-e-stamp-parent',
    templateUrl: './e-stamp-parent.component.html',
    styleUrls: ['./e-stamp-parent.component.scss'],
    standalone: false
})
export class EStampParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
